/**
 * Friendly messages for backend business-rule errors that arrive as a stable key
 * (e.g. a 409 whose body message is `ASSIGNMENT.MOBILITY_MISMATCH`). Keep the keys
 * exactly as the backend sends them.
 */
const BUSINESS_ERROR_MESSAGES: Record<string, string> = {
  'ASSIGNMENT.MOBILITY_MISMATCH': $localize`Il livello di mobilità della terapia non corrisponde a quello attuale del paziente. Aggiorna la mobilità della terapia o del paziente prima di assegnarlo.`,
};

/**
 * Maps a backend error message/key to a user-facing message. Known keys become a
 * localized sentence; anything else (already a human message) is returned as-is.
 */
export function translateBusinessError(message: string): string {
  return BUSINESS_ERROR_MESSAGES[message] ?? message;
}
